import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const TITLE = 'title'
const GRADE_LEVEL = 'grade_level'

/**
 * Form model
 */
const formModel = () => {
  return {
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true,
    },
    [GRADE_LEVEL]: {
      label: `${t('common.grade-level')}`,
      name: GRADE_LEVEL,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TITLE]: '',
  [GRADE_LEVEL]: null,
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [TITLE]: yup
      .string()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
